import { createAction } from '../../utils/redux-helper';
import * as ActionDefinitions from './actionDefinitions';

export const fetchStarted = () => {
  const payload = {};
  return createAction(ActionDefinitions.FETCH_STARTED, payload);
};

export const fetchCompleted = () => {
  const payload = {};
  return createAction(ActionDefinitions.FETCH_COMPLETED, payload);
};

export const setContactInfo = (hasProfile, email) => {
  const payload = {
    hasProfile,
    email
  };
  return createAction(ActionDefinitions.SET_CONTACT_INFO, payload);
};

export const setMessage = (type) => {
  const payload = {
    type
  };
  return createAction(ActionDefinitions.SET_MESSAGE, payload);
};

export const setFingerprint = (fingerprint) => {
  const payload = { fingerprint };
  return createAction(ActionDefinitions.SET_FINGERPRINT, payload);
};
